module.exports = __webpack_public_path__ + "media/integrations/shopify_right-313a51ff.svg";